export default "__VITE_ASSET__DbQF_e$n__"